export default "__VITE_ASSET__BxnJnToY__"